import React, { lazy } from 'react'
import { Route, Switch, useRouteMatch } from '@fs/zion-router'
import config from './chinese-config'

const LandingPage = lazy(() => import('../../pages/LandingPage/LandingPage'))

export default function Router() {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route component={WrappedLandingPage} path={`${path}/`} />
    </Switch>
  )
}

function WrappedLandingPage() {
  return <LandingPage config={config} />
}
